var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpWhiteLeagues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38411 0.460932L7.81309 3.37571C8.75917 4.511 9.23221 5.07865 9.01644 5.53932C8.80067 6 8.06176 6 6.58393 6L3.41607 6C1.93824 6 1.19933 6 0.983561 5.53932C0.767792 5.07865 1.24083 4.511 2.18691 3.37571L2.18691 3.37571L4.61589 0.460933C4.7939 0.247319 4.88291 0.140512 5 0.140512C5.11709 0.140512 5.2061 0.247319 5.38411 0.460932Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpWhiteLeagues);
export default __webpack_public_path__ + "static/media/arrow_up_white_leagues.353b0a97c71351c72cf2263511435566.svg";
export { ForwardRef as ReactComponent };